/*
 * Liive menus (snippets/liive-drawer-menu.liquid, snippets/liive-mega-menu.liquid).
 *
 * Mobile drawer: each [data-liive-accordion] button toggles its panel. One
 * panel open at a time. Listeners are delegated on document so they survive
 * the header being re-rendered by the Section Rendering API.
 *
 * Desktop mega panel: Escape closes the open panel and returns focus to its
 * top-level link. (The drawer's own Escape handling closes the drawer.)
 */

if (!window.__liiveMenu) {
  window.__liiveMenu = true;

  /** @param {HTMLElement} button @param {boolean} open */
  const setOpen = (button, open) => {
    button.setAttribute('aria-expanded', String(open));
    const panel = document.getElementById(button.getAttribute('aria-controls') || '');
    if (panel) panel.classList.toggle('liive-drawer__panel--open', open);
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target?.closest('[data-liive-accordion]');
    if (!(button instanceof HTMLElement)) return;

    event.preventDefault();
    const open = button.getAttribute('aria-expanded') !== 'true';
    const list = button.closest('.liive-drawer');
    list?.querySelectorAll('[data-liive-accordion][aria-expanded="true"]').forEach((other) => {
      if (other !== button && other instanceof HTMLElement) setOpen(other, false);
    });
    setOpen(button, open);

    // Closing the panel above can push the bar out of view; bring it back once the panels settle.
    if (open) {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      setTimeout(() => button.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' }), reduce ? 0 : 240);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const active = document.activeElement;
    if (!(active instanceof HTMLElement)) return;

    const menu = active.closest('header-menu');
    if (!menu) return;

    const item = active.closest('.menu-list__list-item');
    const link = item?.querySelector('[ref="menuitem"]');
    if (!(link instanceof HTMLElement) || link.getAttribute('aria-expanded') !== 'true') return;

    if (active !== link) link.focus();
    // header-menu.js exposes deactivate(event); a keydown with no relatedTarget closes immediately.
    if (typeof menu.deactivate === 'function') {
      menu.deactivate({ target: link, relatedTarget: null, type: 'keydown' });
    }
  });
}
